import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReferalRoutingModule } from './referal-routing.module';
import { ReportComponent } from './report/report.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgSelectModule } from '@ng-select/ng-select';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { MatMenuModule } from '@angular/material/menu';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    ReportComponent
  ],
  imports: [
    CommonModule,
    ReferalRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,  
    NgxSpinnerModule,
    NgSelectModule,
    PipeModule,
    MatMenuModule,
    NgbModule
  ]
})
export class ReferalModule { }
